import { type ButtonProps } from "@heroui/react";
import { MessageCircle } from "lucide-react";

import { useDialog } from "../../contexts/DialogContext";
import { Button } from "../core/Button";

const OpenChatButton = ({
  compact,
  className,
  onPress,
  ...props
}: ButtonProps & { compact?: boolean }) => {
  const { dispatch } = useDialog();

  return (
    <Button
      {...props}
      aria-label={props["aria-label"] ?? "Chat"}
      className={
        compact === undefined
          ? className
          : `${className ? `${className} ` : ""}header-action-button${compact ? " header-action-button--compact" : ""}`
      }
      isIconOnly={compact === undefined ? props.isIconOnly : undefined}
      onPress={(event) => {
        onPress?.(event);
        dispatch({ action: "OPEN_DIALOG", dialog: { id: "CHAT_INFO" } })
      }}
    >
      <MessageCircle aria-hidden="true" size={18} />
      {!props.isIconOnly && (
        <p className="header-button-label header-button-label--short">Chat</p>
      )}
    </Button>
  );
};

export default OpenChatButton;
